<template>
    <div class="container box-like" @click.stop="() => selectedId = -1">
        <div class="button-box">
            <a-popover placement="bottomRight" v-model="showRepayMoreMethod" title="批量销账方式" trigger="click" v-if="selectedRowKeys.length">
                <div slot="content">
                    <a-select style="width: 100%; margin-bottom: 8px;" placeholder="请选择批量销账方式" v-model="repayMoreMethodId">
                        <a-select-option :value="index" v-for="(item, index) in payment" :key="index">{{item}}</a-select-option>
                    </a-select>
                    <a-button type="primary" @click="submitMoreRepay">完成</a-button>
                </div>
                <a-button icon="ordered-list" type="danger">批量销账</a-button>
            </a-popover>
            <div v-else></div>
            <a-button icon="retweet" @click="onFilterAllReset" style="margin-left: 8px">重置所有筛选条件</a-button>
        </div>
        <!-- scroll: 页面太小的时候会让表格至少有相应的长度，如果表格项很少就去掉这个，表格项太多的话适当增加 -->
        <a-table :data-source="tableData" :columns="columns" :rowKey="(rec) => rec.id" :scroll="{ x: 1500, y: 76 * 8 }"
            :pagination="pageConfig" :row-selection="{ selectedRowKeys, onChange: onSelectChange }">
            <!-- slot对应配置文件中customRender的内容 -->
            <div slot="c-detail" slot-scope="text">
                <a-popover title="订单详情">
                    <template slot="content">
                        <table border="1" cellpadding="6" style="text-align: center;">
                            <tr>
                                <th>商品类型</th>
                                <th>商品规格</th>
                                <th>总数量</th>
                                <th>总重量</th>
                                <th>总价</th>
                                <th>备注</th>
                            </tr>
                            <tr v-for="(item, index) in text" :key="index">
                                <td>{{item.goodsname}}</td>
                                <td>{{item.specification}}</td>
                                <td>{{item.amount}}</td>
                                <td>{{item.weight}}</td>
                                <td>{{item.money}}</td>
                                <td>{{item.remark}}</td>
                            </tr>
                        </table>
                    </template>
                    <a>点击查看详情</a>
                </a-popover>
            </div>
            <div slot="c-type" slot-scope="text">
                <a-switch :checked="Boolean(2 - text)" disabled />
            </div>
            <div slot="c-money" slot-scope="text, record">
                <div>{{text || record.summoney}}</div>
            </div>
            <div slot="c-action" slot-scope="text, record" style="display: flex; justify-content: center;" @click.stop="() => null">
                <a-popover placement="bottomRight" :visible="selectedId == record.id" title="销账方式" trigger="click">
                    <div slot="content">
                        <a-select style="width: 100%; margin-bottom: 8px;" placeholder="请选择销账方式" v-model="repayMethodId">
                            <a-select-option :value="index" v-for="(item, index) in payment" :key="index">{{item}}</a-select-option>
                        </a-select>
                        <a-button type="primary" @click="submitRepay(record.id)">完成</a-button>
                    </div>
                    <a-button type="primary" @click="() => selectedId = record.id">销账</a-button>
                </a-popover>
            </div>
            <div slot="filterDropdown" slot-scope="{ confirm, column }" style="padding: 8px">
                <a-input class="filter-input" :placeholder="`搜索${column.title}`" v-model="filterItems[column.filterIndex]"
                    v-if="column.type === 'input'" />
                <a-select class="filter-select" :placeholder="`请选择${column.title}`" :mode="column.multi ? 'multiple' : ''"
                    v-model="filterItems[column.filterIndex]" v-if="column.type === 'select'">
                    <a-select-option :value="item.id" v-for="(item, index) in column.items" :key="index">{{item.name}}</a-select-option>
                </a-select>
                <a-range-picker class="filter-range" valueFormat="YYYY-MM-DD" v-model="filterItems[column.filterIndex]"
                    v-if="column.type === 'range'" />
                <div class="filter-button">
                    <a-button type="primary" icon="search" size="small" @click="onFilterSearch(confirm)">搜索</a-button>
                    <a-button icon="retweet" size="small" @click="onFilterReset(column.filterIndex, confirm)">重置</a-button>
                </div>
            </div>
            <a-icon slot="filterIcon" slot-scope="filtered" type="search" :style="{ color: filtered ? '#108ee9' : undefined }" />
        </a-table>
    </div>
</template>

<script>
import {
    mapState,
    mapMutations
} from 'vuex'
import {
    stationMap,
    payment
} from '@/common/project-config'
import {
    columns
} from './repay.conf.js'

export default {
    name: 'order_repay',
    computed: {
        ...mapState('stored', ['userInfo']),
        payment: () => {
            let _payment = { ...payment}
            delete _payment['2']
            return _payment
        }
    },
    data() {
        return {
            // 当前选中的id，只有编辑的时候需要，新增时改为-1
            selectedId: -1,
            // 当前选中的id组
            selectedRowKeys: [],
            // 表格数据
            tableData: [],
            // 显示编辑内容
            showModal: false,
            // 筛选内容
            filterItems: {},
            // 表格配置，在配置文件里
            columns: [...columns],
            // 分页配置
            pageConfig: {
                current: 1,
                pageSize: 8,
                total: 0,
                pageSizeOptions: ['8', '20', '50', '100', '500'],
                showSizeChanger: true,
                onChange: (a, b) => {
                    this.pageConfig.current = a
                    this.pageConfig.pageSize = b
                    this.onInit()
                },
                onShowSizeChange: (a, b) => {
                    this.pageConfig.current = 1
                    this.pageConfig.pageSize = b
                    this.onInit()
                }
            },
            // 销账方式id
            repayMethodId: '1',
            // 显示批量销账方式列表
            showRepayMoreMethod: false,
            // 批量销账方式id
            repayMoreMethodId: '1'
        }
    },
    created() {

    },
    mounted() {
        this.onInit(true)
    },
    props: {

    },
    watch: {

    },
    methods: {
        ...mapMutations('global', ['setLoading']),
        async onInit(reMap) {
            // 开始loading
            this.setLoading('页面加载中...')
            if (reMap) {
                await this.initMap()
            }
            // 请求地址，在controller里面编辑
            let res = await this.$util.request(this.$ctrl.order.get, {
                status: this.userInfo.stationId,
                page: this.pageConfig.current,
                limit: this.pageConfig.pageSize,
                is_type: 2,
                ...this.filterItems
            })
            // 如果需要对后端返回的值进行转换在这里转
            this.tableData = res.data.data.map((s) => {
                let _s = { ...s}
                _s.status = stationMap[_s.status]
                return _s
            })
            // 其它的逻辑写在这里
            this.pageConfig.total = res.data.total
            // 结束loading
            this.setLoading('')
        },
        async initMap() {
            // 一般情况下，这里写的是选择型的筛选条件的选项，从后端获取
            let res, index
            // 区域管理
            // res = await this.$util.request(this.$ctrl.area.get, {
            //     status: this.userInfo.stationId,
            // })
            // index = this.columns.findIndex((s) => s.filterIndex === 'area_id')
            // this.columns[index].items = res.data.data
            // 支付方式
            index = this.columns.findIndex((s) => s.filterIndex === 'pay')
            this.columns[index].items = Object.entries(payment).reduce((p, [k, v]) => [
                ...p, {
                    id: k,
                    name: v
                }
            ], [])
            // // 客户类型
            // res = await this.$util.request(this.$ctrl.guest_type.get, {
            //      status: this.userInfo.stationId,
            // })
            // index = this.columns.findIndex((s) => s.dataIndex === 'typename')
            // this.columns[index].items = this.formModel.ctyid.items = res.data.data
        },
        onFilterSearch(confirm) {
            this.pageConfig.current = 1
            this.onInit()
            confirm()
        },
        onFilterReset(key, confirm) {
            if (this.filterItems.hasOwnProperty(key)) {
                this.filterItems[key] = ''
                this.onInit()
                confirm()
            }
        },
        onFilterAllReset() {
            Object.keys(this.filterItems).forEach((k) => {
                this.filterItems[k] = undefined
            })
            this.pageConfig.current = 1
            this.onInit()
        },
        onSelectChange(e) {
            this.selectedRowKeys = e
        },
        submitRepay(id) {
            this.selectedId = 0
            this.$confirm({
                title: '提示',
                content: `销账方式为：${this.payment[this.repayMethodId]}，确定要销账吗？`,
                okText: '确定',
                cancelText: '取消',
                okType: 'danger',
                centered: true,
                onOk: () => {
                    this.$util.request(this.$ctrl.order.repay, {
                        id: [id].flat(2),
                        pay: this.repayMethodId
                    }).then((res) => {
                        if (res.code === 1) {
                            this.$success({
                                title: '提示',
                                content: '销账成功',
                                centered: true
                            })
                            if (this.tableData.length <= 1 && this.pageConfig.current > 1) {
                                this.pageConfig.current -= 1
                            }
                            this.onInit()
                        } else {
                            this.$error({
                                title: '提示',
                                content: '销账失败',
                                centered: true
                            })
                        }
                    })
                }
            })
        },
        submitMoreRepay() {
            this.submitRepay(this.selectedRowKeys)
        }
    }
}
</script>

<style scoped lang="less">
    @import './repay.less';
</style>
